import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { show_error, show_success, htmlEscape, dataTruncate } from "lib/helpers"

// address_book_contacts/show_list — data-controller="address-book-contacts--show-list"
export default class extends Controller {
  static targets = ["table", "contactDialog"]

  static values = {
    contactsPath: String,
    removeContactsPath: String,
  }

  connect() {
    if (!this.hasTableTarget) return
    this.#initDataTable()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    $(this.element).off(".contactsList")
    $("#check-all").off(".contactsList")
  }

  openContactDialog(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.contactId
    const path = `${this.contactsPathValue}/edit/${id}`
    $(this.contactDialogTarget).load(path, () => {
      $("#contact-modal").modal("show")
    })
  }

  updateContact(event) {
    event.preventDefault()
    const form = event.currentTarget.closest("form") || document.getElementById("update_form")
    if (!form) return

    $.post(form.action, $(form).serialize())
      .always((response) => {
        if (response.success === true) {
          show_success(response.message)
        } else {
          show_error(response.message)
        }
      })

    $("#contact-modal").modal("hide")
    this.dataTable.ajax.reload()
  }

  removeContact(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.contactId
    if (!id) return
    if (!confirm("Are you sure?")) return

    $(".dataTables_processing").css("display", "block")

    $.get(this.removeContactsPathValue, { item_ids: [id] })
      .always((response) => {
        if (response.success === true) {
          show_success(response.message)
        } else {
          show_error(response.message)
        }
      })
      .done(() => {
        $("#contact-modal").modal("hide")
        this.dataTable.ajax.reload()
      })
  }

  removeSelected(event) {
    if (event) event.preventDefault()

    const groupName = $("input#check-all").val()
    const checkboxes = $(`input[name^='${groupName}']:checked`)
    const available = $(`input[name^='${groupName}']`)

    if (!available.length) return
    if (!checkboxes.length) {
      alert("Please select at least one item")
      return
    }
    if (!confirm("Are you sure? All selected items will be removed")) return

    $(".dataTables_processing").css("display", "block")

    const ids = $.makeArray(checkboxes.map(function () { return $(this).val() }))

    $.get(this.removeContactsPathValue, { item_ids: ids })
      .always((response) => {
        if (response.success === true) {
          show_success(response.message)
        } else {
          show_error(response.message)
        }
      })
      .done(() => this.dataTable.ajax.reload())
  }

  #initDataTable() {
    const $table = $(this.tableTarget)

    this.dataTable = createTurboDataTable($table, {
      dom: '<"H"lfr>t<"F"ip<"toolbar">>',
      pagingType: "full_numbers",
      serverSide: true,
      bPaginate: true,
      order: [1, "asc"],
      language: { searchPlaceholder: "At least 3 symbols" },
      ajax: {
        url: window.location.pathname + window.location.search,
        type: "GET",
      },
      initComplete: () => $("#loading").hide(),
      footerCallback: () => $("#check-all-dialogs").attr("checked", false),
      columnDefs: [
        {
          targets: 0,
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox-row" id="check--usercontacts${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--usercontacts${cellData}"><label/>`,
            )
          },
        },
        {
          targets: 1,
          name: "Phone",
          createdCell: (cell, cellData) => {
            $(cell).html(dataTruncate(cellData, 20))
          },
        },
        {
          targets: 2,
          name: "Name",
          createdCell: (cell, cellData) => {
            const data = htmlEscape(cellData).substring(0, 40)
            $(cell).html(dataTruncate(data))
          },
        },
        {
          targets: 3,
          name: "User Device ID",
          createdCell: (cell, cellData) => {
            const udid = htmlEscape(cellData).substring(0, 50)
            $(cell).html(dataTruncate(udid))
          },
        },
        {
          targets: 4,
          name: "Actions",
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<a href="#" data-contact-id="${cellData}" data-action="click->address-book-contacts--show-list#openContactDialog">Edit</a>`,
            )
          },
        },
        { targets: [0, 4], sortable: false },
      ],
    })

    if ($("#reader").val() === "false") {
      $(".toolbar").html(
        '<br><a href="#" class="remove" data-action="click->address-book-contacts--show-list#removeSelected">Remove selected</a>',
      )
    }

    $("#check-all").on("change.contactsList", function () {
      $(".table-checkbox-row").prop("checked", this.checked)
    })

    $(this.element).on("change.contactsList", ".table-checkbox-row", function () {
      const selectedCount = $(".table-checkbox-row:checked").length
      const totalCount = $(".table-checkbox-row").length
      $("#check-all").prop("checked", selectedCount === totalCount)
    })
  }
}
